import * as React from 'react'

function CertificateCheckmark(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.643 26.321a1.49 1.49 0 011.104.296l1.444 1.108a1.327 1.327 0 001.617 0l1.499-1.15a1.328 1.328 0 01.982-.263l1.875.247a1.329 1.329 0 001.401-.81l.722-1.744a1.326 1.326 0 01.72-.72l1.744-.721a1.328 1.328 0 00.809-1.401l-.237-1.807a1.489 1.489 0 01.296-1.104l1.108-1.444a1.327 1.327 0 000-1.617l-1.151-1.499a1.329 1.329 0 01-.263-.983l.247-1.874a1.329 1.329 0 00-.81-1.402l-1.743-.721a1.324 1.324 0 01-.72-.72l-.722-1.744a1.328 1.328 0 00-1.401-.81l-1.875.247a1.32 1.32 0 01-.981-.26l-1.499-1.15a1.327 1.327 0 00-1.617 0l-1.499 1.15c-.28.214-.633.308-.982.263l-1.875-.247a1.33 1.33 0 00-1.401.81l-.72 1.744a1.341 1.341 0 01-.72.72l-1.744.72a1.33 1.33 0 00-.81 1.401l.247 1.875c.045.349-.049.701-.263.981l-1.15 1.499a1.327 1.327 0 000 1.617l1.15 1.499c.215.28.31.633.263.982l-.247 1.875a1.33 1.33 0 00.81 1.401l1.744.722a1.324 1.324 0 01.72.72l.721 1.744a1.328 1.328 0 001.401.809l1.806-.239"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.732 14.135l-4.668 4.668-2.799-2.8"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { CertificateCheckmark }
